import React from 'react';
import { Link } from 'react-router-dom';

const variantClassNames = {
  primary: 'btn btn-primary',
  secondary: 'btn btn-secondary',
  danger: 'btn btn-danger',
  ghost: 'btn btn-ghost',
  subtle: 'btn btn-subtle',
  tile: 'action-tile',
};

const sizeClassNames = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
  icon: 'btn-icon',
};

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

const Button = React.forwardRef(({
  as: Component,
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  type = 'button',
  ...props
}, ref) => {
  const classNames = joinClassNames(
    variantClassNames[variant] || variantClassNames.primary,
    sizeClassNames[size] || '',
    className
  );

  if (to) {
    return (
      <Link ref={ref} to={to} className={classNames} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a ref={ref} href={href} className={classNames} {...props}>
        {children}
      </a>
    );
  }

  const Element = Component || 'button';

  return (
    <Element ref={ref} type={Element === 'button' ? type : undefined} className={classNames} {...props}>
      {children}
    </Element>
  );
});

Button.displayName = 'Button';

export default Button;
